module.exports = __webpack_public_path__ + "assets/img/2609.ebb79d59.png";